import axios from '../../axios'
import { takeLatest, call, put, select } from 'redux-saga/effects'
import md5 from 'md5'
import { createAction, Action } from 'redux-actions'
import {
  validatePlan,
  decompressPlan,
  hydratePlan,
  hydratePlanWithMinimalForHash,
  hydratePlanWithTeaCodes,
  makePlanHashId
} from '../../../services/compressPlan'
import { actionCreators as gradPlannerActionCreators } from '../../reducers/gradPlanner/gradPlannerActions'
import { actionCreators as uiActionCreators } from '../../reducers/ui/uiActions'
// Saga action strings
export const FETCH_COURSES = 'saga/GradPlanner/FETCH_COURSES'
export const FETCH_COURSES_SUCCESS = 'saga/GradPlanner/FETCH_COURSES_SUCCESS'
export const FETCH_COURSES_FAILURE = 'saga/GradPlanner/FETCH_COURSES_FAILURE'
export const LOAD_DEHYDRATED_PLAN = 'saga/GradPlanner/LOAD_DEHYDRATED_PLAN'
export const actions = {
  FETCH_COURSES,
  FETCH_COURSES_SUCCESS,
  FETCH_COURSES_FAILURE,
  LOAD_DEHYDRATED_PLAN
}

type GradPlannerSagaActionCreators = {
  fetchCourses: () => Action<any>,
  fetchCoursesSuccess: number => Action<any>,
  fetchCoursesFailure: Object => Action<any>,
  decompressPlan: Object => Action<any>
}

export const actionCreators: GradPlannerSagaActionCreators = {
  fetchCourses: createAction(FETCH_COURSES),
  fetchCoursesSuccess: createAction(FETCH_COURSES_SUCCESS),
  fetchCoursesFailure: createAction(FETCH_COURSES_FAILURE),
  reHydratePlan: createAction(LOAD_DEHYDRATED_PLAN)
}

export default function * watchGradPlanner () {
  yield takeLatest(FETCH_COURSES, getCourses)
  yield takeLatest(LOAD_DEHYDRATED_PLAN, loadDehydratedPlan)
}

export function * loadDehydratedPlan (action) {
  if (action.payload) {
    yield put(gradPlannerActionCreators.changeCurrentStep(7))
    const plan = decompressPlan(action.payload)
    const hydrateVersion = plan.hydrate_version
    if (hydrateVersion === 2) {
      // console.log('hydrateVersion is 2')
    }
    yield getCourses({ payload: plan.school.code })
    const courses = yield select(state => state.gradPlanner.courses)
    plan.agency_key = plan.agency_key || process.env.AGENCY_KEY
    const hydratedPlanMinimalForHash = yield call(hydratePlanWithMinimalForHash, plan, courses)
    const hydratedPlanWithTeaCodes = yield call(hydratePlanWithTeaCodes, plan, courses)
    hydratedPlanWithTeaCodes['dt_last_visit_guest'] = new Date().toISOString()
    hydratedPlanWithTeaCodes.agency_key = plan.agency_key || process.env.AGENCY_KEY
    hydratedPlanMinimalForHash.agency_key = plan.agency_key || process.env.AGENCY_KEY
    hydratedPlanWithTeaCodes.plan_key = makePlanHashId(JSON.stringify(hydratedPlanMinimalForHash))
    const repoInfo = yield call(axios.post, '/planhistory', hydratedPlanWithTeaCodes)
    const isValidPlan = yield call(validatePlan, plan, courses)
    if (!isValidPlan) {
      console.log('Previously bookmarked PLAN is no longer valid')
    } else {
      const hydratedPlan = yield call(hydratePlan, plan, courses)
      yield put(gradPlannerActionCreators.changePlan(hydratedPlan))
      yield put(gradPlannerActionCreators.changeCurrentStep(7))
    }
  }
}

export function * getCourses (action) {
  try {
    const courses = yield call(axios.get, `courses/${action.payload}`)
    const activeCourses = courses.data.filter(function (chunk) {
      return chunk.is_course_active === true && chunk.is_tea_course_active === true
    })
    const inactiveCourses = courses.data.filter(function (chunk) {
      return chunk.is_course_active !== true || chunk.is_tea_course_active !== true
    })

    courses.data = activeCourses
    courses.inactiveCourses = inactiveCourses

    yield put(actionCreators.fetchCoursesSuccess(courses.data))
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      yield put(
        actionCreators.fetchCoursesFailure(error.response.data.errors[0])
      )
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      yield put(actionCreators.fetchCoursesFailure(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      yield put(actionCreators.fetchCoursesFailure(error.message))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/gradPlanner/gradPlannerSaga.js